import { IUIRuntime } from '@cian/mf-registry/browser';

import {
  TGetChatbotFiltersMicrofrontendResponse,
  fetchGetChatbotFiltersMicrofrontend,
} from '../repositories/mobile-filters-frontend';
import { IApplicationContext } from '../types/applicationContext';
import { mapManifestForComponent } from '../utils/mapManifestForComponent';

const DEGRADATION_TELEMETRY_KEY = 'degradation.chatbotFilters';

export async function fetchChatbotFiltersManifest(context: IApplicationContext) {
  const { httpApi, microfrontendsRegistry, logger, telemetry } = context;

  try {
    const response: TGetChatbotFiltersMicrofrontendResponse = await fetchGetChatbotFiltersMicrofrontend({ httpApi });

    if (response.statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);
      logger.warning(response.response.message, {
        domain: 'src/shared/services/fetchChatbotFiltersManifest.ts [fetchChatbotFiltersManifest]',
        message: 'Не удалось получить манифест микрофронта фильтров чатбота',
        errors: response.response.errors,
      });

      return null;
    }

    const chatbotFiltersMicrofrontendManifest = response.response.manifest;

    const image = microfrontendsRegistry.register(chatbotFiltersMicrofrontendManifest);

    /* istanbul ignore next */
    if (typeof window !== 'undefined') {
      const runtime = image.runtimeStrict<IUIRuntime>(chatbotFiltersMicrofrontendManifest.runtimeName);
      await runtime.ensure();
    }

    return mapManifestForComponent(chatbotFiltersMicrofrontendManifest);
  } catch (error) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(error, {
      domain: 'src/shared/services/fetchChatbotFiltersManifest.ts [fetchChatbotFiltersManifest]',
      message: 'Не удалось получить манифест микрофронта фильтров чатбота',
    });

    return null;
  }
}
